import qs from 'qs';
import objectToFormData from 'object-to-formdata';
import http from '../http.js';

const convertToFormdata = function(json_data) {
  let formdata = objectToFormData(json_data, { indices: true });
  // Fix for nested fields like contact_email[0].email
  // If data is an empty array, remove it.
  for (let field_id in json_data) {
    if (Array.isArray(json_data[field_id])) {
      if (json_data[field_id].length == 0) {
        delete json_data[field_id];
      }
    }
  }
  return formdata;
};

const querySerialize = function(query_params) {
  return {
    params: query_params,
    paramsSerializer: function(params) {
      return qs.stringify(params, {
        arrayFormat: 'indices',
        encode: false,
      });
    },
  };
};

export default {
  user: {
    fetch(query) {
      return http.get(`/admin/user`, { params: query });
    },
    show(uuid) {
      return http.get(`/admin/user/${uuid}`);
    },
    role(uuid, role) {
      return http.put(`/admin/user/${uuid}/role/${role}`);
    },
    lock(uuid) {
      return http.put(`/admin/user/${uuid}/state/lock`);
    },
    unlock(uuid) {
      return http.put(`/admin/user/${uuid}/state/unlock`);
    },
    me: function(uid) {
      return http.get(`/me/${uid}`, null);
    },
    logout: function(uuid) {
      return http.post(`/logout/${uuid}`);
    },
  },

  advert: {
    fetch: function(query) {
      return http.get(`/admin/property`, querySerialize(query));
    },

    show: function(uuid) {
      return http.get(`/admin/property/${uuid}`);
    },
    publish: function(uuid) {
      return http.put(`/admin/property/${uuid}/publish`);
    },
    unpublish: function(uuid) {
      return http.put(`/admin/property/${uuid}/unpublish`);
    },
    delete(uuid) {
      return http.delete(`/admin/property/${uuid}`);
    },
  },

  preference: {
    fetch: function(query) {
      return http.get(`/admin/preference`, { params: query });
    },

    show: function(uuid) {
      return http.get(`/admin/preference/${uuid}`);
    },
    delete(uuid) {
      return http.delete(`/admin/preference/${uuid}`);
    },
  },

  message: {
    fetch: function(query) {
      return http.get(`/admin/conversation`, { params: query });
    },

    show: function(uuid) {
      return http.get(`/admin/conversation/${uuid}`);
    },
    verify: function(uuid) {
      return http.put(`/admin/conversation/${uuid}/verify`);
    },
    reject: function(uuid) {
      return http.put(`/admin/conversation/${uuid}/reject`);
    },
  },
};
